import layoutHeaderAside from '@/layout/header-aside'

import Preview from '@/pages/preview';

export default {
  path: '/preview',
  component: Preview,
  meta: {
    requiresAuth: true,
    title: '流水概览',
  }
}